import { message } from "antd";

/** Normalize FastAPI `detail` (string | validation array | object) to a single user-facing string. */
export function normalizeApiDetail(detail: unknown): string {
  if (detail === null || detail === undefined) {
    return "";
  }
  if (typeof detail === "string") {
    return detail.trim();
  }
  if (Array.isArray(detail)) {
    return detail
      .map(item => {
        if (typeof item === "string") {
          return item;
        }
        if (item && typeof item === "object" && "msg" in item) {
          return String((item as { msg?: string }).msg ?? "");
        }
        return "";
      })
      .filter(Boolean)
      .join(" ");
  }
  if (typeof detail === "object" && detail !== null && "message" in detail) {
    return String((detail as { message?: unknown }).message ?? "").trim();
  }
  return String(detail).trim();
}

export const getThrownApiDetail = (error: unknown): string =>
  normalizeApiDetail((error as { detail?: unknown } | null)?.detail);

export type ShowApiDetailToastOptions = {
  duration?: number;
  /** Extra offset from top of viewport (e.g. below fixed header). */
  marginTop?: number;
};

/**
 * Global toast for API `detail` strings (limits, 429, etc.) — DataTram primary styling via `.datatram-api-detail-toast`.
 */
export function showApiDetailToast(
  detail: unknown,
  options?: ShowApiDetailToastOptions,
): void {
  const text = normalizeApiDetail(detail);
  const duration = options?.duration ?? 8;
  const marginTop = options?.marginTop ?? 72;

  message.open({
    type: "info",
    content: text || "Something went wrong. Please try again.",
    duration: text ? duration : 5,
    className: "datatram-api-detail-toast",
    style: { marginTop },
  });
}
